import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import AdminManagement from "../components/AdminManagement/AdminManagement"
import { fetchAdminList } from "../actions/adminmanagement";
import { fetchUserInfo } from "../actions/user";

const mapStateToProps = (state) => {
  return {
    isFetching: state.adminManagement.isFetching,
    data: state.adminManagement.data,
    count: state.adminManagement.count,
    error: state.adminManagement.error,

    user_info: state.login.user_info,
  };
};

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      fetchAdminList,
      fetchUserInfo
    },
    dispatch
  );

export default connect(mapStateToProps, mapDispatchToProps)(AdminManagement);
